import { DataSourcesService } from '../services'

export default (templateId) => {
  return new Promise((resolve, reject) => {
    DataSourcesService.system(templateId)
      .then(response => resolve(response.data))
      .catch(err => console.log(err))
  })
}
